"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Products = void 0;
const enums_1 = require("../enums");
/**
 * This is essentially a duplicate of basic subscription info we've
 * created in IAPHUB, but server still needs some basic info about
 * each product/subscription type
 */
const productData = [
    {
        sku: enums_1.ProductSkus.FPMonthlySubscription,
        type: enums_1.ProductType.RENEWABLE_SUBSCRIPTION,
        groupName: enums_1.SubscriptionGroupNames.FULL_THROTTLE,
        subscriptionDuration: enums_1.SubscriptionPeriods.PER_1_MONTH,
    },
    {
        sku: enums_1.ProductSkus.FPYearlySubscription,
        type: enums_1.ProductType.RENEWABLE_SUBSCRIPTION,
        groupName: enums_1.SubscriptionGroupNames.FULL_THROTTLE,
        subscriptionDuration: enums_1.SubscriptionPeriods.PER_1_YEAR,
    },
    {
        sku: enums_1.ProductSkus.TestingWeeklySubscription,
        type: enums_1.ProductType.RENEWABLE_SUBSCRIPTION,
        groupName: enums_1.SubscriptionGroupNames.INTERNAL_SUBSCRIPTION_TESTING,
        subscriptionDuration: enums_1.SubscriptionPeriods.PER_1_WEEK_ANDROID,
    },
    {
        sku: enums_1.ProductSkus.TestingMonthlySubscription,
        type: enums_1.ProductType.RENEWABLE_SUBSCRIPTION,
        groupName: enums_1.SubscriptionGroupNames.INTERNAL_SUBSCRIPTION_TESTING,
        subscriptionDuration: enums_1.SubscriptionPeriods.PER_1_MONTH,
    },
];
exports.Products = {
    /**
     * Returns all product data
     */
    fetch: () => {
        return productData;
    },
    /**
     * Return product by sku
     */
    find: (sku) => {
        return productData.find((p) => p.sku === sku);
    },
};
